export default class UriBuilder {
  private anchorParameters: { [key: string]: string; } = {}

  private readonly baseUrl: string;

  private parameters: { [key: string]: string; } = {}

  public constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public addAnchorParameter(name: string, value: string): void {
    this.anchorParameters[name] = value;
  }

  public addParameter(name: string, value: string): void {
    this.parameters[name] = value;
  }

  public buildUrl(): string {
    let finalUrl = this.baseUrl;
    if (this.hasParameters()) {
      finalUrl += '?' + this.buildParameters(this.parameters);
    }
    if (this.hasAnchorParameters()) {
      finalUrl += '#' + this.buildParameters(this.anchorParameters);
    }
    return finalUrl;
  }

  private buildParameters(parameters: { [key: string]: string; }): string {
    const encodedParameters = [];
    for (const parameterName in parameters) {
      encodedParameters.push(encodeURIComponent(parameterName) + '=' + encodeURIComponent(parameters[parameterName]));
    }
    return encodedParameters.join('&');
  }

  private hasAnchorParameters(): boolean {
    return Object.keys(this.anchorParameters).length > 0;
  }

  private hasParameters(): boolean {
    return Object.keys(this.parameters).length > 0;
  }
}
